var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import Loading from "./components/Loading";
import LoadingContext from "./contexts/Loading";
import { RouterManager } from "./routes/RouterManager";
import ErrorFeedback from "./components/ErrorFeedback";
export var App = function () {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var obj = useMemo(function () { return ({ isLoading: isLoading, setIsLoading: setIsLoading }); }, [isLoading]);
    return (_jsx(LoadingContext.Provider, __assign({ value: obj }, { children: _jsxs("div", __assign({ className: "font-sans flex flex-col items-center pt-9 pb-40" }, { children: [_jsx(ErrorFeedback, {}), _jsx(RouterManager, {}), _jsx(Loading, {})] })) })));
};
